(function () {
  "use strict";

  function initScrollAnimations() {
    if (window._scrollObserver) {
      window._scrollObserver.disconnect();
    }

    const observerOptions = {
      threshold: 0.08,
      rootMargin: "-80px 0px -50px 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const el = entry.target;

        if (entry.isIntersecting) {
          el.classList.add("is-visible");
          el.classList.add("has-been-seen");
        } else if (el.classList.contains("has-been-seen")) {
          el.classList.remove("is-visible");
        }
      });
    }, observerOptions);

    document.querySelectorAll("[data-animate]").forEach((el) => {
      observer.observe(el);
    });

    document.querySelectorAll("[data-animate-group]").forEach((group) => {
      Array.from(group.children).forEach((child) => {
        if (!child.hasAttribute("data-animate")) {
          child.setAttribute("data-animate", "fade-up");
        }
        observer.observe(child);
      });
    });

    window._scrollObserver = observer;
  }

  window.initScrollAnimations = initScrollAnimations;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initScrollAnimations, {
      once: true,
    });
  } else {
    initScrollAnimations();
  }
})();
